/**
 * FileIcon - Icon representing a file/document
 * Line-based document with folded corner
 */

import type { IconProps } from './IconTypes';

export function FileIcon({
  size = 20,
  className = '',
  'aria-label': ariaLabel = 'File',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      {/* Document body with folded corner */}
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      {/* Folded corner */}
      <polyline points="14 2 14 8 20 8" />
    </svg>
  );
}
